// removed by extract-text-webpack-plugin
module.exports = {"detail":"src-display-apps-InvoiceInput-detail__detail--29_zk","detail-form":"src-display-apps-InvoiceInput-detail__detail-form--hYjrQ","detail-handle":"src-display-apps-InvoiceInput-detail__detail-handle--5uS_v"};


//////////////////
// WEBPACK FOOTER
// ./src/display/apps/InvoiceInput/detail.scss
// module id = 4182
// module chunks = 0